module.exports = __webpack_public_path__ + "media/images/how_it_works/project_holder-ebf91a78ac8cde0786769bb2cf9c087a.svg";